<template>

    <div class="row">
        <div class="col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3 col-lg-4 col-lg-offset-4">
            <div class="box box-danger">
                <div class="box-header">
                    <h2 class="box-title">Contract actief maken voor gebruiker: {{ getHrUser.fullname }}</h2>
                </div>
                <div class="box-body">
                    <p class="form-control-static">Weet je zeker dat dit contract actief wilt maken?</p>
                    <p class="form-control-static">Door dit contract te activeren:</p>
                    <ul>
                        <li>Wordt er een contractnummer toegewezen aan dit contract</li>
                        <li>Kan dit contract <u><strong>niet</strong></u> meer worden aangepast</li>
                    </ul>
                    <p class="form-control-static"><strong>LET OP:</strong> De startdatum mag niet overlappen met een actief contract.</p>

                    <div class="text-center" v-if="contract !== null && !hasUnsetContract">
                        <div class="btn-group">
                            <button
                                class="btn btn-primary"
                                @click="makeActive"
                            >Ja</button>

                            <button
                                @click="returnBack"
                                class="btn btn-danger"
                            >Nee</button>
                        </div>
                    </div>
                    <div v-else>
                        <div class="alert alert-warning">
                            <p>Het is nog niet mogelijk om dit contract te activeren, omdat er reeds een contract voor onbepaalde tijd actief is (geweest).</p>
                            <p>Stop dit oude contract, voordat er een nieuwe contract aangemaakt kan worden.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import { mapGetters } from "vuex";
import Errors from "../../../../Errors";

export default {

    computed: {
        ...mapGetters([
            'getHrUser',
            'getHrUserContracts',
        ]),

        canSubmit() {
            return this.posting === false;
        },

        contract() {
            if (!this.$route.params.contract_uuid) {
                return null;
            }

            let contract = this.getHrUserContracts.filter(contract => contract.uuid === this.$route.params.contract_uuid);

            return contract.length === 1 ?
                contract[0] :
                null;
        },

        hasUnsetContract() {
            return this.getHrUserContracts.filter(contract => {
                return contract.end === null &&
                    contract.duration === 'unset' &&
                    contract.is_concept !== true;
            }).length > 0;
        },
    },

    data() {
        return {
            errors:new Errors(),
            posting:false,
        }
    },

    methods: {
        makeActive() {
            if (!this.canSubmit) {
                return;
            }
            this.posting = true;
            axios.post(this.route('api.v1.hr.users.contracts.finalize', {id:this.getHrUser.uuid, contract_uuid:this.contract.uuid}), {contract_uuid:this.contract.uuid})
                .then(() => {
                    this.$emit('updateContractdata');
                    this.$snotify.success('Het contract is geactiveerd')
                    this.$router.push({
                        name:'hr.users.contracts',
                        params:{
                            uuid:this.getHrUser.uuid,
                        },
                    })
                })
                .catch(err => {
                    if (err.response.data.errors) {
                        this.errors.record(err.response.data.errors);
                        this.$snotify.error(this.errors.get('contract_uuid'));
                    } else {
                        this.$snotify.error('Er is een fout opgetreden bij het activeren van het contract');
                    }
                })
                .finally(() => this.posting = false);
        },

        returnBack() {
            this.$router.go(-1);
        },
    },

}

</script>
